import { environment } from '@app/environment';
import { ChallengeType } from '@app/models';

export type ResponseChallengeType = 'awaiting_validation'|'validated'|'denied'|'denied_definitely';

export class ResponseChallengeStatus {
    label: string;
    classCSS: string;
    constructor(label: string = 'CHALLENGE_STATUS.TO_DO', classCSS: string = 'to_do'){
        this.label = label;
        this.classCSS = classCSS;
    }
    
    static FromStatus(status: ResponseChallengeType, challengeType: ChallengeType): ResponseChallengeStatus{
        let responseChallengeStatus = new ResponseChallengeStatus();
        switch(status){
            case 'awaiting_validation' :
                responseChallengeStatus = new ResponseChallengeStatus('CHALLENGE_STATUS.AWAITING_VALIDATION', 'awaiting_validation');
                break;
            case 'validated' :
                responseChallengeStatus = new ResponseChallengeStatus('CHALLENGE_STATUS.VALIDATED', 'validated');
                break;
            case 'denied_definitely' :
                responseChallengeStatus = new ResponseChallengeStatus('CHALLENGE_STATUS.DENIED', 'denied_definitely');
                break;
            case 'denied' :                
                if([environment.CHALLENGE_TYPE.DEMONSTRATION, environment.CHALLENGE_TYPE.SALE].indexOf(challengeType) !== -1){
                    responseChallengeStatus = new ResponseChallengeStatus('CHALLENGE_STATUS.DENIED', 'denied_definitely');
                }
                else{
                    responseChallengeStatus = new ResponseChallengeStatus('CHALLENGE_STATUS.DENIED', 'denied');
                }
                break;
        }
        return responseChallengeStatus;
    }
}


export class ResponseChallenge {
    ID: string;
    challengeID: string;
    matchID: string;
    typeResponse: string;
    response: string;
    date: Date;
    status: ResponseChallengeType;
    denialReason: string;
    message: string;
    comment: string;
    optionalsMedias: Array<string>;
    incentive: number;
    devise: string;
    points: number;
}
